module.exports = __webpack_public_path__ + "static/img/lb.03bba993.png";